import {
  Table,
  Row,
  Col,
  Typography,
  Form,
  Select,
  Input,
  Button,
  message,
  Space,
  DatePicker,
  Card,
  Tag
} from "antd";
import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Highlighter from "react-highlight-words";
import api from "../../API";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, EditOutlined, SaveOutlined } from "@ant-design/icons";
import { set } from "lodash";

function NewSegment() {
  const user = JSON.parse(localStorage.getItem('user'));
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [replaceValue, setReplaceValue] = useState({ date: false, input: true});
  const originalTableData = useRef([]);
  const dataFilterByBtn = useRef([]);
  const [formData, setformData] = useState([]);
  const prevFormData = useRef([]);
  const [segment, setSegment] = useState();
  const createdId = useRef();
  const { segmentId } = useParams();
  const [inputBorder, setInputBorder] = useState("");
  const [OAId, setOAId] = useState(null);
  const [OAIdOptions, setOAIdOptions] = useState([]);
  const isFirstRender = useRef(true);
  const [tagColors, setTagColors] = useState(new Map());
  
  const TAG_COLORS = ['magenta', 'red', 'volcano', 'orange', 'gold', 'lime', 'green', 'cyan', 'blue', 'geekblue', 'purple'];

  const columns = [
    {
      title: "Name",
      dataIndex: "display_name",
      width: 150,
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "UID",
      dataIndex: "zaloUid",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "Address",
      dataIndex: "address",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "Ward",
      dataIndex: "ward",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "District",
      dataIndex: "district",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "City",
      dataIndex: "city",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "Tags",
      dataIndex: "tags",
      width: 130,
      render: (arr) => {
        if (!arr?.length) return '';
        
        return (
          <Space wrap size={0.5}>
            {arr.map((tag, i) => {
              if (!tag) return null;
              
              if (searchText && tag.toLowerCase().includes(searchText.toLowerCase())) {
                return (
                  <Tag color={tagColors.get(tag)} key={i}>
                    <Highlighter
                      highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                      }}
                      searchWords={[searchText]}
                      autoEscape
                      textToHighlight={tag}
                    />
                  </Tag>
                );
              }
              
              return <Tag color={tagColors.get(tag)} key={i}>{tag}</Tag>;
            })}
          </Space>
        );
      }
    },
  ];

  const handleInputChange = (index, field, changedValue) => {
    const updatedFormData = [...formData];
    updatedFormData[index][field] = changedValue;
    if (field === "value") {
      updatedFormData[index].isValueEmpty = changedValue === "" ? true : false;
    }
    setformData(updatedFormData);
  };

  const handleNameChange = (value) => {
    setSegment(value);
    if (value.trim().length > 0) {
      setInputBorder("");
    } else {
      setInputBorder("1px solid red");
    }
  };

  const handleAddForm = () => {
    let isAllFilled = true;
    const updatedFormData = formData.map((form) => {
      if (form.value === "") {
        isAllFilled = false;
        return { ...form, isValueEmpty: true };
      }
      return { ...form, isValueEmpty: false };
    });

    setformData(updatedFormData);

    if (isAllFilled) {
      setformData([
        ...formData,
        {
          operator: "AND",
          attribute: "Gender",
          condition: "=",
          value: "",
          isValueEmpty: false,
        },
      ]);
    }
  };

  const removeForm = (index) => {
    const newFormData = formData.filter((_, i) => i !== index);
    setformData(newFormData);
  };

  const navigate = useNavigate();

  const handleSave = async () => {
    if (segment && segment.length !== 0) {
      if (window.location.pathname.includes("new")) {
        try {
          const response = await api.create_new_segment({segmentName: segment, createdDate: time(), createdBy: 1});
          createdId.current = response.id;
          if (createdId.current) await Promise.all([
            api.create_new_segmentsDetails(generateSegmentDetails()),
            api.create_new_contactSegments(generateContactSegment())
          ]);
          message.success("Segment created successfully!");
          navigate("/contacts/segments");
        } catch (error) {
          message.error(error.message);
          console.error("Error creating segment:", error);
        }
      } else if (window.location.pathname.includes("edit")) {
        try {
          if (segmentId && segment) await Promise.all([
            api.update_segment(segmentId, {id: segmentId, segmentName: segment, createdDate: time(), createdBy: 1,}),
            api.update_segmentDetails(segmentId, generateSegmentDetails()),
            api.update_contactSegments(segmentId, generateContactSegment())
          ]);
          message.success("Segment updated successfully!");
          navigate("/contacts/segments");
        } catch (error) {
          message.error(error.message);
          console.error("Error updating segment:", error);
        }
      }
    } else {
      setInputBorder("1px solid red");
    }
  };

  const time = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDateTime;
  };

  const generateContactSegment = () => {
    const jsonData = {};
    dataSource.forEach((entry, index) => {
      jsonData[index] = {
        segmentId: createdId.current ? createdId.current : segmentId,
        contactId: entry.key,
      };
    });
    return jsonData;
  };

  const generateSegmentDetails = () => {
    const jsonData = {};
    formData.forEach((entry, index) => {
      if (entry.value)
        //comment to save include empty value
        jsonData[index] = {
          segmentId: createdId.current ? createdId.current : segmentId,
          conditionKey: `${entry.operator} ${entry.attribute} ${entry.condition}`,
          conditionValue: entry.value,
        };
    });
    return jsonData;
  };

  const generateSegmentConditions = (userId, OAId) => {
    const jsonData = {userId, OAId};
    formData.forEach((entry, index) => {
      if (entry.value) {
        jsonData[index] = {
          type: entry.operator,
          attribute: entry.attribute,
          condition: entry.condition,
          value: entry.value,
        };
      }
    });
    return jsonData;
  };

  useEffect(() => {
    setLoading(true);
    if (!(window.location.pathname.includes("edit") && isFirstRender.current) && OAId) {
      api
        .list_contacts_by_conditions(generateSegmentConditions(user?.userId ,OAId))
        .then((contacts) => {
          const uniqueTags = new Set();
          contacts.forEach(contact => {
            const tags = contact.tags?.split(',') || [];
            tags.forEach(tag => tag && uniqueTags.add(tag));
          });
    
          const tagColorMap = new Map();
          Array.from(uniqueTags).forEach((tag, index) => {
            tagColorMap.set(tag, TAG_COLORS[index % TAG_COLORS.length]);
          });
          setTagColors(tagColorMap);
          let newContacts = contacts.map((contact) => ({
            key: contact.id,
            display_name: contact.display_name,
            zaloUid: contact.zaloUid,
            phone: contact.phone,
            address: contact.address,
            ward: contact.ward,
            tags: contact.tags?.split(',').filter(Boolean),
            district: contact.district,
            city: contact.city,
          }));
          originalTableData.current = [...newContacts];
          dataFilterByBtn.current = [...newContacts];
          setDataSource(newContacts);
        })
        .catch((error) => message.error(error.message));
    }
    if (prevFormData.current !== formData) {
      isFirstRender.current = false;
    }
    setLoading(false);
  }, [formData, OAId]);

  useEffect(() => {
    api.list_oaaccounts_by_user(user?.userId, user?.parentId,["id", "accountName", "OAId"]).then(oaaccounts => 
      setOAIdOptions(oaaccounts.map(oaaccount => ({
        value: oaaccount.OAId,
        label: oaaccount.accountName
    }))))
    if (window.location.pathname.includes("edit")) {
      api.view_segment(segmentId).then((seg) => {
        setSegment(seg[0].segmentName);
      });
      api
        .view_segmentDetails(segmentId)
        .then((details) => {
          details = details.map((entry) => {
            const [operator, attribute, condition] =
              entry.conditionKey.split(" ");
            return {
              operator: operator,
              attribute: attribute,
              condition: condition,
              value: entry.conditionValue,
            };
          });
          if (details.length !== 0) {
            setformData(details);
            prevFormData.current = details;
          } else {
            handleAddForm();
          }
        })
        .catch((error) => message.error(error.message));
      api
        .list_contacts_by_segmentId(segmentId)
        .then((contacts) => {
          const uniqueTags = new Set();
          contacts.forEach(contact => {
            const tags = contact.tags?.split(',') || [];
            tags.forEach(tag => tag && uniqueTags.add(tag));
          });
    
          const tagColorMap = new Map();
          Array.from(uniqueTags).forEach((tag, index) => {
            tagColorMap.set(tag, TAG_COLORS[index % TAG_COLORS.length]);
          });
          setTagColors(tagColorMap);
          const newContacts = contacts.map((contact) => {
            return ({
              key: contact.id,
              display_name: contact.display_name,
              zaloUid: contact.zaloUid,
              phone: contact.phone,
              address: contact.address,
              tags: contact.tags?.split(',').filter(Boolean),
              ward: contact.ward,
              district: contact.district,
              city: contact.city,
          })});
          originalTableData.current = [...newContacts];
          dataFilterByBtn.current = [...newContacts];
          setOAId(contacts[0].OAId);
          setDataSource(newContacts);
        })
        .catch((error) => message.error(error.message));
    } else {
      handleAddForm();
    }
  }, []);

  return (
    <Card 
      style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
      title={
        <Space>
          <Link to="/contacts/segments">
            <Button style={{width: 50}} icon={<ArrowLeftOutlined />} />
          </Link>
          <Typography.Title level={5} style={{ margin: 0 }}>
            {segmentId? "Update": "Create New"} Segment
          </Typography.Title>
        </Space>
      }
      loading={loading}
    >
      <Row style={{marginBottom: 16}}>
        <Col span={24}>
          <Select
            options={OAIdOptions}
            onChange={(selectedValue) => setOAId(selectedValue)}
            value={OAId}
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            placeholder="Select your OA account first"
            popupMatchSelectWidth={false}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Input
            value={segment}
            onChange={(e) => handleNameChange(e.target.value)}
            placeholder="Input your segment name"
            style={{ border: inputBorder }}
          />
        </Col>
      </Row>
      <Row style={{marginTop: 16}}>
        {formData.map((form, index) => (
          <Form
            layout="horizontal"
            style={{ display: "block" }}
            key={index}
          >
            {index !== 0 && (
              <Form.Item
                label="Type"
                style={{ display: "block", width: "150px", margin: "0 0 20px" }}
              >
                <Select
                  defaultValue={form.operator}
                  onChange={(value) =>
                    handleInputChange(index, "operator", value)
                  }
                >
                  <Select.Option value="AND">AND</Select.Option>
                  <Select.Option value="OR">OR</Select.Option>
                </Select>
              </Form.Item>
            )}
            <Space size={10} wrap>
              <Form.Item label="Attribute">
                <Select
                  defaultValue={form.attribute}
                  style={{ width: 220 }}
                  onChange={(value) =>{
                    if(value === "LastInteract") setReplaceValue({date: true, input: false});
                    else setReplaceValue({input: true, date: false});
                    handleInputChange(index, "attribute", value)
                  }}
                >
                  <Select.Option value="gender">Gender</Select.Option>
                  <Select.Option value="Phone">Phone</Select.Option>
                  <Select.Option value="Address">Address</Select.Option>
                  <Select.Option value="Ward">Ward</Select.Option>
                  <Select.Option value="District">District</Select.Option>
                  <Select.Option value="City">City</Select.Option>
                  <Select.Option value="Tags">Tags</Select.Option>
                  <Select.Option value="LastInteract">
                    Last Interact with OA
                  </Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label="Condition">
                <Select
                  defaultValue={form.condition}
                  style={{ width: 220 }}
                  onChange={(value) =>
                    handleInputChange(index, "condition", value)
                  }
                >
                  <Select.Option value="=">Equal</Select.Option>
                  <Select.Option value="!=">Not Equal</Select.Option>
                  <Select.Option value="LIKE">Contains</Select.Option>
                  <Select.Option value="<=">Before</Select.Option>
                  <Select.Option value=">=">After</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label="Value" name='value' style={{ marginLeft: 10 }} rules={[{ required: true, message: "Please input value!" }]}>
                {replaceValue.input && <Input
                  value={form.value}
                  onChange={(e) => {
                    handleInputChange(index, "value", e.target.value);
                  }}
                />}
                {replaceValue.date && <DatePicker onChange={(_,dayStr) => handleInputChange(index, "value", dayStr)}/>}
              </Form.Item>
              <Form.Item>
                <Space>
                  {index === formData.length - 1 && (
                    <Button type="primary" onClick={() => handleAddForm()}>
                      Add
                    </Button>
                  )}
                  {index >= 1 && formData.length > 1 && (
                    <Button type="primary" onClick={() => removeForm(index)}>
                      Remove
                    </Button>
                  )}
                </Space>
              </Form.Item>
            </Space>
          </Form>
        ))}
      </Row>
      <Row>
        <Col span={24}>
          <Table
            bordered
            scroll={{ x: 1000 }}
            columns={columns}
            style={{ marginTop: 16, width: "100%" }}
            dataSource={dataSource}
            loading={loading}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: false, // Disable page size changer
              pageSize: 10, 
              showTotal: () => `Total: ${dataSource.length} items`
            }}
          />
        </Col>
      </Row>
      <Row>
        <Button type="primary" onClick={handleSave} style={{marginTop: 16}} icon={window.location.pathname.includes("edit")? <EditOutlined/>: <SaveOutlined/>}>
          {window.location.pathname.includes("edit")? "Update": "Save"}
        </Button>
      </Row>
    </Card>
  );
}

export default NewSegment;
